// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3814db0b","86":"ea368e94","129":"1d5fa153","267":"faa78c90","453":"825386d9","520":"130050a0","607":"b7fcb0b1","611":"5487dbc3","630":"31059365","671":"5e01b635","706":"875db9de","763":"e42c24a1"}[chunkId] + ".chunk.js";
};